// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.AudienceFilterDropdownContent {
  position: absolute;
  background: var(--base_color2);
  width: 466px;
  right: 0;
  z-index: 100;
  padding: 21px 16px;
  border-radius: 4px;
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);
}
.AudienceFilterDropdownContent .AudienceDropdownContent-title {
  margin: 20px 0 14px;
  display: flex;
}
.AudienceFilterDropdownContent .AudienceDropdownContent-title .tooltipped {
  margin-left: 8px;
}
.AudienceFilterDropdownContent .audience-options {
  margin: 0 0 20px;
}
.AudienceFilterDropdownContent .audience-options .audience-options-item {
  margin-bottom: 20px;
}
.AudienceFilterDropdownContent .audience-options .audience-options-item > * {
  display: flex;
  flex-wrap: wrap;
  grid-column-gap: 20px;
}
.AudienceFilterDropdownContent .audience-options .audience-options-item .container-ages-buttons {
  display: grid;
  grid-template-columns: auto auto auto auto;
  justify-content: initial;
  grid-gap: 20px;
}
.AudienceFilterDropdownContent .audience-options .audience-options-item .container-ages-buttons .WithLegend:last-child {
  margin: 0;
}
.AudienceFilterDropdownContent .audience-options .audience-options-item .container-ages-buttons .WithLegend:nth-of-type(4) {
  margin: 0;
}
.AudienceFilterDropdownContent .audience-options .audience-options-item .audience-options-item-label {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 700;
  color: var(--gray_dark1);
}
.AudienceFilterDropdownContent .audience-options .audience-options-item .AudienceFilterDropdownContent-filter-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 85px;
  margin: 0 10px 0 0;
}
.AudienceFilterDropdownContent .audience-options .audience-options-item .AudienceFilterDropdownContent-filter-btn:last-child {
  margin: 0;
}
.AudienceFilterDropdownContent .audience-options .audience-options-item button {
  margin: 0 0 5px;
}
.AudienceFilterDropdownContent .audience-options .audience-options-item button svg {
  margin: 3px 0;
  width: 18px;
  height: 18px;
  display: block;
}
.AudienceFilterDropdownContent .audience-options .audience-options-item .audience-country-select {
  width: 433px;
}
.AudienceFilterDropdownContent .audience-actions {
  display: flex;
  justify-content: space-between;
  flex-flow: row;
  margin-top: 32px;
}
.AudienceFilterDropdownContent .audience-actions button {
  margin: 0 8px 0 0;
}
.AudienceFilterDropdownContent .audience-actions button:last-child {
  margin: 0;
}
.AudienceFilterDropdownContent .audience-actions .start {
  justify-self: self-end;
}
.AudienceFilterDropdownContent .audience-actions .buttonWrapper {
  display: flex;
  justify-content: space-between;
  flex-flow: row;
  margin-left: auto;
}
.AudienceFilterDropdownContent .audience-actions .audience-actions-refresh {
  display: flex;
  align-items: center;
  padding-left: 0;
  padding-right: 0;
}
.AudienceFilterDropdownContent .audience-actions .audience-actions-refresh:hover svg {
  transform: rotate(-45deg);
}
.AudienceFilterDropdownContent .audience-actions .audience-actions-refresh svg {
  transition-duration: 0.3s;
  transform: rotate(0deg);
  width: 20px;
  height: 14px;
  margin: 0 4px 0 0;
}

.inner-content {
  padding: 14px 0px 0px 0px;
}

.stored-audience-list {
  margin: 16px 0;
  max-height: 402px;
  display: grid;
  grid-gap: 16px;
  overflow-y: auto;
  width: 100%;
  color: var(--gray);
}
.stored-audience-list::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.stored-audience-list::-webkit-scrollbar-track {
  background: transparent;
}
.stored-audience-list::-webkit-scrollbar-thumb {
  background: var(--color_neutral_200);
  height: 80px;
  border-radius: 50px;
}
.stored-audience-list:hover::-webkit-scrollbar-thumb {
  background: var(--color_neutral_400);
}
.stored-audience-list::-webkit-scrollbar-thumb:active {
  background: var(--color_neutral_500);
}
.stored-audience-list .item {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid var(--gray);
  border-radius: 4px;
  max-width: 274px;
  color: var(--gray_dark2);
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
}
.stored-audience-list .item .content {
  width: 266px;
  padding: 10px;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.stored-audience-list .item .delete {
  width: 40px;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stored-audience-list .active {
  background-color: var(--color_primary_500);
  color: white;
}
.stored-audience-list .active .icon {
  fill: white;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/components/AudienceFilterDropdownContent/index.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,2CAAA;AAeF;AAbE;EACE,mBAAA;EACA,aAAA;AAeJ;AAbI;EACE,gBAAA;AAeN;AAXE;EACE,gBAAA;AAaJ;AAXI;EACE,mBAAA;AAaN;AAXM;EACE,aAAA;EACA,eAAA;EACA,qBAAA;AAaR;AAVM;EACE,aAAA;EACA,0CAAA;EACA,wBAAA;EACA,cAAA;AAYR;AATU;EACE,SAAA;AAWZ;AARU;EACE,SAAA;AAUZ;AALM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;AAOR;AAJM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAMR;AAJQ;EACE,SAAA;AAMV;AAFM;EACE,eAAA;AAIR;AAFQ;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAIV;AAAM;EACE,YAAA;AAER;AAGE;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,gBAAA;AADJ;AAGI;EACE,iBAAA;AADN;AAGM;EACE,SAAA;AADR;AAKI;EACE,sBAAA;AAHN;AAMI;EACE,aAAA;EACA,8BAAA;EACA,cAAA;EACA,iBAAA;AAJN;AAOI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AALN;AAQQ;EACE,yBAAA;AANV;AAUM;EACE,yBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AARR;;AAcA;EACE,yBAAA;AAXF;;AAcA;EACE,cAAA;EACA,iBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAXF;ADxHE;EACE,UAAA;EACA,WAAA;AC0HJ;ADvHE;EACE,uBAAA;ACyHJ;ADtHE;EACE,oCAdM;EAeN,YAAA;EACA,mBAAA;ACwHJ;ADpHI;EACE,oCApBS;AC0If;ADlHE;EACE,oCAxBY;AC4IhB;AAHE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,2BAAA;EAAA,wBAAA;EAAA,mBAAA;AAKJ;AAHI;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAKN;AAFI;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAIN;AAAE;EACE,0CAAA;EACA,YAAA;AAEJ;AAAI;EACE,WAAA;AAEN","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.AudienceFilterDropdownContent {\n  position: absolute;\n  background: var(--base_color2);\n  width: 466px;\n  right: 0;\n  z-index: 100;\n  padding: 21px 16px;\n  border-radius: 4px;\n  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.1);\n\n  .AudienceDropdownContent-title {\n    margin: 20px 0 14px;\n    display: flex;\n\n    .tooltipped {\n      margin-left: 8px;\n    }\n  }\n\n  .audience-options {\n    margin: 0 0 20px;\n\n    .audience-options-item {\n      margin-bottom: 20px;\n\n      >* {\n        display: flex;\n        flex-wrap: wrap;\n        grid-column-gap: 20px;\n      }\n\n      .container-ages-buttons {\n        display: grid;\n        grid-template-columns: auto auto auto auto;\n        justify-content: initial;\n        grid-gap: 20px;\n\n        .WithLegend {\n          &:last-child {\n            margin: 0;\n          }\n\n          &:nth-of-type(4) {\n            margin: 0;\n          }\n        }\n      }\n\n      .audience-options-item-label {\n        margin: 0 0 12px;\n        font-size: 14px;\n        font-weight: 700;\n        color: var(--gray_dark1);\n      }\n\n      .AudienceFilterDropdownContent-filter-btn {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 85px;\n        margin: 0 10px 0 0;\n\n        &:last-child {\n          margin: 0;\n        }\n      }\n\n      button {\n        margin: 0 0 5px;\n\n        svg {\n          margin: 3px 0;\n          width: 18px;\n          height: 18px;\n          display: block;\n        }\n      }\n\n      .audience-country-select {\n        width: 433px;\n      }\n    }\n  }\n\n  .audience-actions {\n    display: flex;\n    justify-content: space-between;\n    flex-flow: row;\n    margin-top: 32px;\n\n    button {\n      margin: 0 8px 0 0;\n\n      &:last-child {\n        margin: 0;\n      }\n    }\n\n    .start {\n      justify-self: self-end;\n    }\n\n    .buttonWrapper {\n      display: flex;\n      justify-content: space-between;\n      flex-flow: row;\n      margin-left: auto;\n    }\n\n    .audience-actions-refresh {\n      display: flex;\n      align-items: center;\n      padding-left: 0;\n      padding-right: 0;\n\n      &:hover {\n        svg {\n          transform: rotate(-45deg);\n        }\n      }\n\n      svg {\n        transition-duration: 0.3s;\n        transform: rotate(0deg);\n        width: 20px;\n        height: 14px;\n        margin: 0 4px 0 0;\n      }\n    }\n  }\n}\n\n.inner-content {\n  padding: 14px 0px 0px 0px;\n}\n\n.stored-audience-list {\n  margin: 16px 0;\n  max-height: 402px;\n  display: grid;\n  grid-gap: 16px;\n  overflow-y: auto;\n  width: 100%;\n  color: var(--gray);\n\n  @include scrollbar;\n\n  .item {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    border: 1px solid var(--gray);\n    border-radius: 4px;\n    max-width: 274px;\n    color: var(--gray_dark2);\n    height: fit-content;\n\n    .content {\n      width: 266px;\n      padding: 10px;\n      font-size: 14px;\n      font-weight: 400;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .delete {\n      width: 40px;\n      font-size: 1.2rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n  .active {\n    background-color: var(--color_primary_500);\n    color: white;\n\n    .icon {\n      fill: white;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
